import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { criarRoteador } from './app/rotas';
import { ProvedorSessao } from './features/auth/ProvedorSessao';
import { registrarServiceWorker } from './lib/instalacao';
import './styles/global.css';

const clienteConsultas = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false } },
});

registrarServiceWorker();

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('Elemento #raiz não encontrado no index.html');

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={clienteConsultas}>
      <ProvedorSessao>
        <RouterProvider router={criarRoteador()} />
      </ProvedorSessao>
    </QueryClientProvider>
  </StrictMode>,
);
